import { API_ENDPOINTS, GAME_DEFAULTS } from '../config/constants';

/**
 * Service for handling API requests.
 */

/**
 * Sends a request to initialize and join bots.
 * @param {Object} payload - The bot configuration.
 * @param {string} payload.pin - The game PIN.
 * @param {number} payload.amount - The number of bots.
 * @param {string} payload.name - The base name for the bots.
 * @param {string} payload.clientId - The socket client ID.
 * @param {boolean} payload.teamMode - Whether team mode is enabled.
 * @returns {Promise<Object>} The JSON response from the server.
 */
export const spawnBotsRequest = async (payload) => {
    const params = new URLSearchParams({
        pin: String(payload.pin),
        amount: String(payload.amount),
        name: payload.name || GAME_DEFAULTS.DEFAULT_BOT_NAME,
        clientId: payload.clientId,
        teamMode: String(payload.teamMode),
        recaptchaToken: "true"
    });

    const res = await fetch(API_ENDPOINTS.INIT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString()
    });

    if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.description || "An unknown error occurred");
    }

    return res.json();
};

/**
 * Fetches global bot statistics.
 * @returns {Promise<Object>} The statistics data.
 */
export const fetchStatsRequest = async () => {
    const res = await fetch(API_ENDPOINTS.STATS);
    if (!res.ok) {
        throw new Error("Failed to fetch stats");
    }
    return res.json();
};
